import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
@Injectable({
  providedIn: 'root'
})
export class OtherProfileService {

  constructor(private _apiService: ApiService) { }

  otherProfile(id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.USERS}${API_ENDPOINTS.API.OTHER_PROFILE}/${id}`
    return this._apiService.get(url)
  }

  otherUserContent(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.OTHER_USER_CONTENT}`;
    return this._apiService.get(url, data);
  }

  getAdvertisementSpace(user_id){
    const url=`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PUBLIC_PROFILE_ADVERTISEMENTS}?user_id=${user_id}`;
    return this._apiService.get(url);
  }

  otherprofileData:any
  otherprofileIdFirstTime:any

}
